import { API_ERROR_MESSAGE, NO_RESULTS_FOUND } from '../../utils/Constants'
import { API_CALL_TYPE, getAPIUrl } from '../API'
import { ProductIds, ReportTypes } from '../apiConstants'
import { makeApiCall } from '../APIService'
import moment from 'moment'
interface HandleSanctionScreeningSearchConsumerProps {
  identityNumber: string
  firstName: string
  lastName: string
  dateOfBirth?: string | null
  reference: string
  country: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
  setSanctionScreeningConsumers: (value: []) => void
}

export const handleSanctionScreeningSearchConsumer = ({
  identityNumber,
  firstName,
  lastName,
  dateOfBirth,
  reference,
  setShowProgress,
  setIsError,
  setErrorMessage,
  setSanctionScreeningConsumers,
}: HandleSanctionScreeningSearchConsumerProps): void => {
  const API_URL = `${getAPIUrl()}/Common/search-consumer`
  const body = {
    identityNumber,
    firstName,
    lastName,
    dateOfBirth,
    passportNumber: identityNumber,
    purpose: '',
    reference,
    telephone: '',
    reportType: ReportTypes.SanctionScreeningReport.reportTypeId,
    productId: ProductIds.SanctionScreeningReport.productId,
    searchType: 1,
    birthYear: undefined,
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')
  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response: { statusCode: number; data: [] }) => {
      console.log(response)
      if (response.data.length === 0) {
        setShowProgress(false)
        let searchCriteria = ''

        if (identityNumber)
          searchCriteria += `Identity Number: ${identityNumber} `
        if (firstName) searchCriteria += `First Name: ${firstName} `
        if (lastName) searchCriteria += `Last Name: ${lastName} `
        if (dateOfBirth)
          searchCriteria += `Date of Birth: ${moment(dateOfBirth).format(
            'YYYY-MM-DD',
          )} `

        alert(`No results found for: ${searchCriteria}`)
        setErrorMessage(NO_RESULTS_FOUND)
      } else {
        setShowProgress(false)
        setSanctionScreeningConsumers(response.data)
      }
    },
    (error: { response: { data: { message: string } } }) => {
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    },
    null,
    false,
  )
}

interface HandleSanctionScreeningLoadReportProps {
  identityNumber: string
  sanctionScreeningConsumer: {
    enquiryID?: string
    enquiryResultID?: string
  }
  reference: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
  setReportId: (value: string) => void
  downloadReport: (reportId?: string) => void
}

export const handleSanctionScreeningLoadReport = ({
  identityNumber,
  sanctionScreeningConsumer,
  reference,
  setShowProgress,
  setIsError,
  setErrorMessage,
  setReportId,
  downloadReport,
}: HandleSanctionScreeningLoadReportProps): void => {
  const API_URL = `${getAPIUrl()}/SanctionScreening/load-report`
  const body = {
    identityNumber,
    reference,
    purpose: '',
    enquiryID: sanctionScreeningConsumer?.enquiryID,
    enquiryResultID: sanctionScreeningConsumer?.enquiryResultID,
    productId: ProductIds.SanctionScreeningReport.productId,
    reportType: ReportTypes.SanctionScreeningReport.reportTypeId,
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')
  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response: { statusCode: number; data: { reportId: string } }) => {
      if (response.statusCode !== 200) {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      } else {
        downloadReport(response.data.reportId)
        setReportId(response.data.reportId)
        setShowProgress(false)
      }
    },
    (error: { response: { data: { message: string } } }) => {
      console.log(error)
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    },
    null,
    false,
  )
}

interface HandleSanctionScreeningDownloadReportProps {
  reportId: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
}

export const handleSanctionScreeningDownloadReport = (
  props: HandleSanctionScreeningDownloadReportProps,
): void => {
  const { reportId, setShowProgress, setIsError, setErrorMessage } = props
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify({
      reportId,
      reportType: ReportTypes.SanctionScreeningReport.reportTypeId,
    }),
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')

  fetch(`${getAPIUrl()}/SanctionScreening/download-report`, requestOptions)
    .then((res: Response) => {
      return res.blob()
    })
    .then((blob: Blob) => {
      setShowProgress(false)
      const href = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', 'SanctionScreening.pdf')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    .catch((error) => {
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
      return Promise.reject({ Error: 'Something Went Wrong', error })
    })
}
